import React from 'react';
import PubSub from 'pubsub-js';
import { useLocalStorage } from 'react-use';

interface IProps {
  v1: any;
  v2: any;
}

const CheckSwitchLayout = (props: IProps) => {
  const [pangoLayoutVersion, setPangoLayoutVersion] = useLocalStorage('pango-layout-version', undefined as any);

  React.useEffect(() => {
    PubSub.subscribe('CHANGE_LAYOUT', (data: any, v: any) => {
      if (v === 'v2') {
        setPangoLayoutVersion('v2');
      }
      if (v === 'v1') {
        setPangoLayoutVersion('v1');
      }
    });
  }, []);

  const renderLayout = () => {
    if (pangoLayoutVersion === undefined || pangoLayoutVersion === 'v1') {
      return props.v1('v1');
    } else if (pangoLayoutVersion === 'v2') {
      return props.v2('v2');
    }
    return props.v1('v1');
  };

  return renderLayout();
};

export default CheckSwitchLayout;
